import type { HTMLAttributes, ReactNode } from 'react';

import { cn } from '../../lib/utils.js';

export type BadgeVariant =
  | 'default'
  | 'neutral'
  | 'primary'
  | 'success'
  | 'warning'
  | 'danger'
  | 'info'
  | 'purple'
  | 'amber'
  | 'solid-primary'
  | 'solid-danger';

export interface BadgeProps extends HTMLAttributes<HTMLSpanElement> {
  variant?: BadgeVariant;
  dot?: boolean;
  children: ReactNode;
}

const variantClassName: Record<BadgeVariant, string | undefined> = {
  default: undefined,
  neutral: 'badge--neutral',
  primary: 'badge--primary',
  success: 'badge--success',
  warning: 'badge--warning',
  danger: 'badge--danger',
  info: 'badge--info',
  purple: 'badge--purple',
  amber: 'badge--amber',
  'solid-primary': 'badge--solid-primary',
  'solid-danger': 'badge--solid-danger',
};

export function Badge({
  variant = 'default',
  dot = false,
  className,
  children,
  ...props
}: BadgeProps) {
  return (
    <span
      className={cn('badge', variantClassName[variant], dot && 'badge--dot', className)}
      {...props}
    >
      {children}
    </span>
  );
}
